// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1635px) {
	.nav-text {
		font-size: 17px !important;
	}
	.nav_text_container {
		gap: 1 !important;
	}
	.nav_logo {
		height: 55px !important;
	}
	.NavContainer {
		width: 96% !important;
	}

	.hero_section_container {
		width: 95% !important;
	}
}

@media screen and (max-width: 1610px) {
	.nav-text {
		font-size: 15px !important;
	}
	.nav_text_container {
		gap: 1 !important;
	}
	.nav_logo {
		height: 50px !important;
	}
	.NavContainer {
		width: 97% !important;
	}

	.hero_section_container {
		width: 98% !important;
	}
}

@media screen and (max-width: 1510px) {
	.hero_section_container {
		width: 99% !important;
	}
}

@media screen and (max-width: 1250px) {
	.nav-text {
		font-size: 15px !important;
	}
	.nav_text_container {
		gap: 5px !important;
	}
	.nav_logo {
		height: 45px !important;
	}
	.NavContainer {
		width: 98% !important;
	}
}

@media screen and (max-width: 1000px) {
	.nav_text_container {
		display: none !important;
	}
	.nav_logo {
		height: 40px !important;
	}
	.NavContainer {
		width: 90% !important;
	}
}

/* Phone Input Styles */
.react-tel-input .form-control {
	width: 100% !important;
	height: 40px;
	font-size: 14px;
	border-color: #e0e0e0;
	border-radius: 4px;
}

.react-tel-input .form-control:focus {
	border-color: #a56825;
	box-shadow: 0 0 0 1px #a56825;
}

.react-tel-input .selected-flag:hover,
.react-tel-input .selected-flag:focus {
	background-color: transparent;
}

.react-tel-input .flag-dropdown {
	background-color: transparent;
	border-color: #e0e0e0;
}

.react-tel-input .flag-dropdown.open {
	background-color: transparent;
	border-color: #a56825;
}

.react-tel-input .country-list {
	margin: 4px 0;
	padding: 0;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.react-tel-input .country-list .country:hover {
	background-color: #f5f5f5;
}

.react-tel-input .country-list .country.highlight {
	background-color: #a56825;
}

.MuiBox-root.css-55jbfs {
  height: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Header.css"],"names":[],"mappings":"AAAA;CACC;EACC,0BAA0B;CAC3B;CACA;EACC,iBAAiB;CAClB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,qBAAqB;CACtB;;CAEA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;CACA;EACC,iBAAiB;CAClB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,qBAAqB;CACtB;;CAEA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;CACA;EACC,mBAAmB;CACpB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,qBAAqB;CACtB;AACD;;AAEA,uBAAuB;AACvB;CACC,sBAAsB;CACtB,YAAY;CACZ,eAAe;CACf,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,UAAU;CACV,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["@media screen and (max-width: 1635px) {\n\t.nav-text {\n\t\tfont-size: 17px !important;\n\t}\n\t.nav_text_container {\n\t\tgap: 1 !important;\n\t}\n\t.nav_logo {\n\t\theight: 55px !important;\n\t}\n\t.NavContainer {\n\t\twidth: 96% !important;\n\t}\n\n\t.hero_section_container {\n\t\twidth: 95% !important;\n\t}\n}\n\n@media screen and (max-width: 1610px) {\n\t.nav-text {\n\t\tfont-size: 15px !important;\n\t}\n\t.nav_text_container {\n\t\tgap: 1 !important;\n\t}\n\t.nav_logo {\n\t\theight: 50px !important;\n\t}\n\t.NavContainer {\n\t\twidth: 97% !important;\n\t}\n\n\t.hero_section_container {\n\t\twidth: 98% !important;\n\t}\n}\n\n@media screen and (max-width: 1510px) {\n\t.hero_section_container {\n\t\twidth: 99% !important;\n\t}\n}\n\n@media screen and (max-width: 1250px) {\n\t.nav-text {\n\t\tfont-size: 15px !important;\n\t}\n\t.nav_text_container {\n\t\tgap: 5px !important;\n\t}\n\t.nav_logo {\n\t\theight: 45px !important;\n\t}\n\t.NavContainer {\n\t\twidth: 98% !important;\n\t}\n}\n\n@media screen and (max-width: 1000px) {\n\t.nav_text_container {\n\t\tdisplay: none !important;\n\t}\n\t.nav_logo {\n\t\theight: 40px !important;\n\t}\n\t.NavContainer {\n\t\twidth: 90% !important;\n\t}\n}\n\n/* Phone Input Styles */\n.react-tel-input .form-control {\n\twidth: 100% !important;\n\theight: 40px;\n\tfont-size: 14px;\n\tborder-color: #e0e0e0;\n\tborder-radius: 4px;\n}\n\n.react-tel-input .form-control:focus {\n\tborder-color: #a56825;\n\tbox-shadow: 0 0 0 1px #a56825;\n}\n\n.react-tel-input .selected-flag:hover,\n.react-tel-input .selected-flag:focus {\n\tbackground-color: transparent;\n}\n\n.react-tel-input .flag-dropdown {\n\tbackground-color: transparent;\n\tborder-color: #e0e0e0;\n}\n\n.react-tel-input .flag-dropdown.open {\n\tbackground-color: transparent;\n\tborder-color: #a56825;\n}\n\n.react-tel-input .country-list {\n\tmargin: 4px 0;\n\tpadding: 0;\n\tborder-radius: 4px;\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.react-tel-input .country-list .country:hover {\n\tbackground-color: #f5f5f5;\n}\n\n.react-tel-input .country-list .country.highlight {\n\tbackground-color: #a56825;\n}\n\n.MuiBox-root.css-55jbfs {\n  height: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
